import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { InvalidLinkForExternalComponent } from './components/invalid-link-for-external/invalid-link-for-external.component';
import { SubmittedApprovalComponent } from './components/submitted-approval/submitted-approval.component';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { TipsModule } from '@anecdotes/design-system/tips';
import { LoadersModule } from '@anecdotes/design-system/loaders';

@NgModule({
  imports: [
    CommonModule,
    SvgIconsModule,
    TranslateModule,
    UtilsModule,
    PerfectScrollbarModule,
    ButtonsModule,
    TipsModule,
    LoadersModule,
  ],
  declarations: [SubmittedApprovalComponent, InvalidLinkForExternalComponent],
  exports: [SubmittedApprovalComponent, InvalidLinkForExternalComponent],
})
export class ExternalPageModule {}
